module.exports = __webpack_public_path__ + "static/img/customers.5c705ea.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/casePage/customers.webp
// module id = 0EBM
// module chunks = 0